import React, { useEffect } from 'react';
import { Box } from '@material-ui/core';
import { AccordionSummary } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {
  FirstAccordion,
  StyledCaption,
  StyledAccordionDetails,
  StyledBody,
} from 'components/SecondAccordionFaq/styles';
import { useSelector } from 'react-redux';
import {
  getSelectedFaqIdSelector,
  getSelectedFaqCodeSelector,
} from 'store/global/selectors';
import { scrollFunction } from 'utils/string';

interface SecondAccordionFaqType {
  intl: IntlShape;
  question: string;
  response: string;
  expanded: boolean | String;
  setSelectedFaq: Function;
  id: number;
}

const SecondAccordionFaq = ({
  expanded,
  question,
  response,
  id,
  setSelectedFaq,
  ...props
}: SecondAccordionFaqType) => {
  const expandSelectedFaq = useSelector(getSelectedFaqIdSelector);
  const expandSelectedCodeFaq = useSelector(getSelectedFaqCodeSelector);
  const [expand, setExpanded] = React.useState<string | false>(false);

  useEffect(() => {
    scrollFunction(expandSelectedCodeFaq);
    // eslint-disable-next-line
  }, []);
  const handleChange = (panel: string) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean,
  ) => {
    /* istanbul ignore next */
    setExpanded(isExpanded ? panel : false);
    setSelectedFaq({
      code: '',
      id: '',
    });
  };
  return (
    <>
      <FirstAccordion
        aria-controls={`panel-content-1`}
        id={`panel-header-${id}`}
        data-testid={`releve-situation-item-${id}`}
        onChange={handleChange(`panel-${id}`)}
        expanded={expandSelectedFaq && expandSelectedFaq === id ? true : expand}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Box width="100%">
            <StyledCaption weight="400">{question}</StyledCaption>
          </Box>
        </AccordionSummary>

        <StyledAccordionDetails>
          <Box width="100%">
            <StyledBody>{response}</StyledBody>
          </Box>
        </StyledAccordionDetails>
      </FirstAccordion>
    </>
  );
};

export default injectIntl(SecondAccordionFaq);
